import * as React from 'react'

import Typography from 'common/Typography'

const StepEmpty = () => <Typography variant='h5'>Please contact your issuer to learn how to complete your investment.</Typography>

export default StepEmpty
